import { ItemTypeEnum } from 'mbs-ui-shared@models/backup/storages-type';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';

export enum ArchiveType {
  Files = 0,
  DiskImage = 2,
  HyperV = 5,
  VMware = 6,
  MsSql = 7,
  Proxmox = 8
}

export enum AgentlessProtectionMode {
  None = 0,
  ZipPassword = 1,
  Encrypted = 2
}

export enum BaseArchiveIcons {
  Files = 'assets/images/for-wizards/file-small.svg',
  DiskImage = 'assets/images/for-wizards/ibb-small.svg'
}

export enum IdsForCurrentFormats {
  File = 'Files Backup',
  FileUnix = 'File-level Backup',
  Ibb = 'Image Based',
  HyperV = 'Hyper-V Hosts',
  VMWare = 'VMware Hosts',
  DatabaseFile = 'SQL Server Instances'
}

export enum ArchiveTypeStrings {
  Files = IdsForCurrentFormats.File,
  DiskImage = IdsForCurrentFormats.Ibb,
  HyperV = IdsForCurrentFormats.HyperV,
  VMware = IdsForCurrentFormats.VMWare,
  MsSql = IdsForCurrentFormats.DatabaseFile
}

export const cbfStringMap = {
  [PlanTypes.RestoreHyperV]: IdsForCurrentFormats.HyperV,
  [PlanTypes.RestoreHyperVToCustom]: IdsForCurrentFormats.HyperV,
  [PlanTypes.RestoreVMware]: IdsForCurrentFormats.VMWare,
  [PlanTypes.RestoreVMwareToCustom]: IdsForCurrentFormats.VMWare,
  [PlanTypes.RestoreDiskImagePlan]: IdsForCurrentFormats.Ibb,
  [PlanTypes.RestoreDataBasePlan]: IdsForCurrentFormats.DatabaseFile
};

export const cbfMap = {
  [IdsForCurrentFormats.HyperV]: true,
  [IdsForCurrentFormats.VMWare]: true,
  [IdsForCurrentFormats.Ibb]: true,
  [IdsForCurrentFormats.File]: true,
  [IdsForCurrentFormats.FileUnix]: true,
  [IdsForCurrentFormats.DatabaseFile]: true
};
export enum ArchiveRestorePointSummaryStatus {
  Success,
  Warning,
  Fail,
  Running,
  Unknown,
  DeepSync
}

export interface BunchItem {
  disabled?: boolean;
  itemType?: ItemTypeEnum;
  isNBF?: boolean;
  lastBackupStatus?: ArchiveRestorePointSummaryStatus;
  retentionKeepBackupFor?: number;
  isCurrent?: boolean;
  isEncrypted?: boolean;
  isCanBeDeleted?: boolean;
  isCanBeExpand?: boolean;
  isPlanExists?: boolean;
  bunchId: string;
  path?: string;
  bunchName: string;
  displayName?: string;
  firstRestoreDate: string;
  lastRestoreDate: string;
  originalSize: number;
  sizeOnStorage: number;
  totalSavings: number;
  type: string;
  daysToPurge: number;
  purgeSummary: string;
  countOfErrorRestorePoints?: number;
  countOfSuccessfulRestorePoints?: number;
  countOfWarningRestorePoints?: number;
}

export interface BackupToRestoreStepValue {
  selectedBunch: string;
  backupPlanName?: string;
  bunchId?: string;
  valid: boolean;
}

export interface ComputerBackupStorageItem {
  displayName?: string;
  id?: string;
  isCurrent?: boolean;
  IsCanBeExpand?: boolean;
  isLast?: boolean;
  itemType?: number;
  name?: string;
  path?: string;
}
